export const SELECT_TITLE = "SELECT_TITLE"; 

export const selectTitle = (title: any) => {
  return {
    type: SELECT_TITLE, 
    payload: title,
  };
};
